import apiUrl from '../baseUrls/functions';
import AxiosService from '../axiosConfig/AxiosService';

export default new class MouvementPieceService {
    
    get = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/mouvement-piece/get'), callback, queryParams);
    getById = (id, callback) => AxiosService.get(apiUrl(`/api/crud/mouvement-piece/get/${id}`), callback);
    add = (data, callback) => AxiosService.post(apiUrl('/api/crud/mouvement-piece/add'), data, callback);
    update = (data, callback) => AxiosService.put(apiUrl('/api/crud/mouvement-piece/update'), data, callback);
    delete = (id, callback) => AxiosService.delete(apiUrl(`/api/crud/mouvement-piece/delete/${id}`), callback);
    
}